import apiUrl from '../../../../../utils/settings';



export const AddBeneficiaryUrl = () => {
    return apiUrl + '/benefit-beneficiary/beneficiary';
};
export const getBeneficiaryInfoUrl = () =>{
    return apiUrl + '/benefit-beneficiary/all-beneficiaries';
}
export const getNomineeInfoforSelectedBeneficiaryUrl = () =>{
    return apiUrl + '/benefit-beneficiary/nominees';
}
export const deleteBeneficiaryUserUrl = () => {
    return apiUrl + '/benefit-beneficiary/beneficiary';
};
export const deleteBeneficiaryRelationUrl = () => {
    return apiUrl + '/benefit-beneficiary/benefit-relation';
};
export const updateBeneficiaryInfoUrl = () => {
    return apiUrl + '/benefit-beneficiary/update-beneficiary';
};
export const UserFileUploadUrl = () => {
    return apiUrl + '/users-file/upload-users-id-proof';
};
export const getBeneficiaryRelationsUrl = () =>{
    return apiUrl + '/benefit-beneficiary/beneficiary-relations/all';
}
export const getBenefitTypesUrl = () =>{
    return apiUrl + '/benefit-beneficiary/benefit-types/all';
}
export const getBenefitBeneficiarySummaryUrl = () =>{
    return apiUrl + '/benefit-beneficiary/benefit-beneficiary-summary';
}
export const getBeneficiaryUploadedImageUrl= () =>{
    return apiUrl + '/benefit-beneficiary/beneficiary-pancard-image';
}
export const GstUserPanDataFetchUrl = () => {
    return apiUrl + '/user-pan-and-gst/get-pan-details';
};
export const getAmountForMedicalInsuranceUrl = () => {
    return apiUrl + '/company-benefit-value/get';
};
export const GetAllUserInsuranceCertificateUrl = () => {
    return apiUrl + '/benefit-packages/get-user-certificate-image-by-company-id';
};
export const getBenefitsDataOfUserUrl = () => {
    return apiUrl + '/company-benefit-packages/get-benefit-details';
};
export const GetUserInsuranceCertificateUrl = () => {
    return apiUrl + '/benefit-packages/get-user-certificate-s3-image/';
};